import { ClickAwayListener, IconButton, Popover, Popper } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React, { useEffect } from "react";
import DetailsParams from "../../MainPage/Sections/ElementsSections/DetailsParams";
import { useAtom } from "jotai";
import { editorCash } from "../../../atoms";
export default function DetailsButton(props) {
  const buttonRef = React.useRef();
  const popperRef = React.useRef();
  const [cash, setCash] = useAtom(editorCash);

  // функции для Popover(выпадающим полем) с выбором даты
  const [open, setOpen] = React.useState(false);
  const [position, setPosition] = React.useState({ x: 0, y: 0 });

  useEffect(() => {
    cash.detailsOpen && setOpen(cash.detailsOpen);
  }, []);

  useEffect(() => {
    if (open) {
      setPosition(getPosition());
      setCash({ ...cash, detailsOpen: true });
    }
  }, [open]);

  const handleClickDetails = () => {
    setOpen(!open);
  };
  // функция на закрытие
  const handleCloseDetails = (ev) => {
    if (
      ev.target === buttonRef.current?.closest("TD") ||
      (ev.target.closest(".background_ModalDialog") &&
        ev.target.closest(".background_ModalDialog") !== buttonRef.current?.closest(".background_ModalDialog")) ||
      ev.target.closest("[checklist]") ||
      ev.target.closest("[calendar]") ||
      ev.target.closest("[details]") ||
      ev.target.closest("[loadmask]") ||
      ev.target.classList.contains("MuiBackdrop-root")
    ) {
      return;
    }

    props.details.updateRecord();
    setOpen(false);
    setCash({ ...cash, detailsOpen: false });
  };

  const getPosition = () => {
    if (!popperRef.current || !buttonRef.current) return "";
    const rootRect = document.querySelector("#root").getBoundingClientRect();
    const buttonRect = buttonRef.current.getBoundingClientRect();

    const x = buttonRect.left - 400 < 0 ? 30 : buttonRect.left - 400 + 30;
    const y = buttonRect.top + 250 < rootRect.height - 100 ? buttonRect.top + 27 : buttonRect.top - 250;

    return { x, y };
  };

  return (
    <>
      <IconButton
        disabled={props.disabled}
        ref={(el) => {
          buttonRef.current = el;
          if (props.buttonRef) props.buttonRef.current = el;
        }}
        onClick={handleClickDetails}
        className="list-button"
        style={{
          width: "20px !important",
          height: "100%",
          borderRadius: "0px",
          padding: "0",
        }}
      >
        <ExpandMoreIcon style={{ maxHeight: "20px" }} />
      </IconButton>
      <div
        style={{
          position: "fixed",
          zIndex:
            !buttonRef.current || buttonRef.current.closest(".background_ModalDialog") === null
              ? "999"
              : buttonRef.current.closest("DIV.background_ModalDialog").style.zIndex,
          // width: props.autoCompleteValue.current ? `${props.autoCompleteValue.current.clientWidth}px` : "400px",
          left: position.x,
          top: position.y,
        }}
      >
        {open && (
          <ClickAwayListener onClickAway={handleCloseDetails}>
            <div
              tabIndex={0}
              onWheel={(ev) => {
                ev.stopPropagation();
              }}
              onKeyDown={(ev) => {
                ev.stopPropagation();
              }}
              ref={popperRef}
              details="true"
              style={{
                overflow: "auto",
                height: "fit-content",
                maxHeight: "250px",
                minHeight: "30px",
                minWidth: "400px",
                boxShadow: "rgba(0, 0, 0, 0.2) 3px 3px 3px 2px",
                border: " 1px solid #cccccc;",
                borderRadius: "7px",
              }}
            >
              <DetailsParams
                Module={props.module}
                ID={props.details.ID}
                DocCfgID={props.details.Details}
                NoTitle={true}
                NoHistory={true}
                data={props.details.GetDetails}
                setParentEditorValueInput={props.setInputValue}
                setParentEditorValue={props.setValue}
                valueChanged={props.valueChanged}
                getText={props.details.getText}
                updateRecord={props.details.updateRecord}
                HardCodeReadOnlyForEditor={props.details.HardCodeReadOnlyForEditor}
                AccDetails={props.details.AccDetails}
                inputValue={props.inputValue}
                onList={props.details.GetDetails.OnList}
                onListCustom={props.details.GetDetails.OnListCustom}
                onEdit={props.details.GetDetails.OnEdit}
                onEditCustom={props.details.GetDetails.OnEditCustom}
                onCloseUpList={props.details.GetDetails.OnCloseUpList}
                onCloseUpListCustom={props.details.GetDetails.OnCloseUpListCustom}
              />
            </div>
          </ClickAwayListener>
        )}
      </div>
    </>
  );
}
